<template>
  <div class="physical-chemical">
    <b-row
      v-if="hasPendingLots"
      class="physical-chemical__pending-lots-warning-wrapper"
      align-h="center"
    >
      <b-alert
        v-html="pendingAmountMessage"
        class="physical-chemical__pending-lots-warning"
        variant="warning"
        show
      />
    </b-row>
    <base-panel
      :asset="asset"
      :asset-module="assetModule"
      :hidePrintButton="false"
      :tabs="tabs"
      @change-pending-lots="assignPendingLots"
      :notifications="notifications"
    />
  </div>
</template>

<script>
import tabNames from '@/domain/enums/installation/engineering/physicalChemical/physicalChemicalTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/physicalChemical/GeneralTab';
import AnalysisTab from '@/domain/components/installation/engineering/physicalChemical/AnalysisTab';
import ParametersTab from '@/domain/components/installation/engineering/physicalChemical/ParametersTab';

export default {
  name: 'PhysicalChemical',
  components: {
    BasePanel,
  },
  props: {
    asset: Object,
    assetType: Object,
    assetModule: Object,
    assetGeneralInfo: Object,
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    amountOfPendingLots: 0,
  }),
  computed: {
    hasPendingLots() {
      return this.amountOfPendingLots > 0;
    },
    pendingAmountMessage() {
      return this.$t('engineering.chromatography.general.pending-lots-alert', {
        amountOfPendingLots: this.amountOfPendingLots,
      });
    },
    analysisTabTitle() {
      return this.$route.query.sampleId
        ? 'engineering.physical-chemical.edit-sample'
        : 'engineering.physical-chemical.insert-sample';
    },
    assetHasNoTension() {
      const { superiorTension, inferiorTension, tertiaryTension } = this.assetGeneralInfo || {};
      return !superiorTension && !inferiorTension && !tertiaryTension;
    },
    tabs() {
      return [
        {
          name: tabNames.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
        },
        {
          name: tabNames.SAMPLE,
          title: this.$t(this.analysisTabTitle),
          component: AnalysisTab,
          disabled: this.assetHasNoTension,
          showTooltip: this.assetHasNoTension,
          tooltipMessage: 'messages.ME052.message',
        },
        {
          name: tabNames.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          disabled: this.assetHasNoTension,
          showTooltip: this.assetHasNoTension,
          tooltipMessage: 'messages.ME052.message',
        },
      ];
    },
  },
  methods: {
    assignPendingLots(amountOfPendingLots) {
      this.amountOfPendingLots = amountOfPendingLots;
    },
  },
};
</script>

<style lang="sass" scoped>
  .physical-chemical
    &__pending-lots-warning-wrapper
      position: relative
    &__pending-lots-warning
      position: absolute
      top: -80px
      width: 95%
      text-align: center
      z-index: 1
</style>
